import React from 'react';
import { Typography } from 'components/atoms';
import { InputPro } from 'components/atoms/Input';
import './index.scss';

interface Props {
  onSearch: (term: string) => void;
  searchTerm: string;
  onAcceptanceStatusFilter?: (status: string) => void;
  acceptanceStatusFilter?: string;
  onGoalStatusFilter?: (status: string) => void;
  goalStatusFilter?: string;
}

export const EmployeeReviewFilter = ({ 
  onSearch, 
  searchTerm, 
  onAcceptanceStatusFilter, 
  acceptanceStatusFilter = 'all',
  onGoalStatusFilter,
  goalStatusFilter = 'all'
}: Props) => {
  return (
    <div className="employee-review-filter-container">
      <div className="employee-review-search">
        <InputPro
          name="search"
          label=""
          placeholder="Search by employee name or ID..."
          value={searchTerm}
          onChange={onSearch}
          inputWrapperClass="search-input-wrapper"
          inputClass="search-input"
        />
      </div>
      {(onAcceptanceStatusFilter || onGoalStatusFilter) && (
        <div className="employee-review-filters">
          {onAcceptanceStatusFilter && (
            <div className="filter-group">
              <Typography type="small_medium" text="Acceptance Status" />
              <select
                className="select-input"
                value={acceptanceStatusFilter}
                onChange={(e) => onAcceptanceStatusFilter(e.target.value)}
              >
                <option value="all">All Acceptance Status</option>
                <option value="accepted">Accepted</option>
                <option value="declined">Declined</option>
                <option value="pending">Pending</option>
                <option value="mixed">Mixed</option>
              </select>
            </div>
          )}
          {onGoalStatusFilter && (
            <div className="filter-group">
              <Typography type="small_medium" text="Goal Status" />
              <select
                className="select-input"
                value={goalStatusFilter}
                onChange={(e) => onGoalStatusFilter(e.target.value)}
              >
                <option value="all">All Goal Status</option>
                <option value="completed">Completed</option>
                <option value="ongoing">Ongoing</option>
                <option value="pending">Pending</option>
              </select>
            </div>
          )}
        </div>
      )}
    </div>
  );
}; 